import Vue from "vue";
import VueRouter from "vue-router";
import Store from "../store";
import CreatePayment from "../views/create-payment";
import CompaniesList from "../views/company/companies-list";
import Login from "../views/login";
import PaymentView from "../views/payment-view";
import BulkPaymentView from "../views/bulk-payment-view";
import PaymentDoneView from "../views/payment-done-view";
import PaymentInfoView from "../views/payment-info-view";
import PaymentHistoryList from "../views/payment-history/payment-history-list";
import BulkPaymentHistoryList from "../views/bulk-payment-history/bulk-payment-history-list";
import UsersList from "../views/users/users-list";
import ActivateView from "../views/activate";
import RegistrationView from "../views/registration/registration-view";
import LandingPage from "../views/landingpage/landing-page";
import Dashboard from "../views/dashboard/dashboard";
import SolutionsPage from "../views/solutions/solutions-page";
import SettingsView from "../views/settings/settings-view";
import GeneralSettingsView from "../views/general-settings/general-settings-view";
import Logout from "../views/logout";
import UploadCSV from "../views/upload-csv/upload-csv-view";
import ConsentView from "../views/consent/consent-view"
import OnboardingView from "../views/onboarding/app/onboarding-view"
import OnboardingList from "../views/onboarding/admin/onboarding-list"
import AccountSelectView from "@/views/account-select-view.vue";
Vue.use(VueRouter);

const routes = [
    {
        path: "/admin/payment/create",
        name: "create-payment",
        component: CreatePayment,
        meta: {
            title: "Payment create",
            requires_auth: true
        }
    },
    {
        path: "/admin/upload-csv",
        name: "upload-csv",
        component: UploadCSV,
        meta: {
            title: "Upload CSV",
            requires_auth: true
        }
    },
    {
        path: "/",
        redirect: "/app/login"
    },
    {
        path: "/admin",
        redirect: "/app/login"
    },
    {
        path: "/app",
        redirect: "/app/login"
    },
    {
        path: "/admin/dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
            requires_auth: true
        }
    },
    {
        path: "/admin/landing",
        name: "Landing",
        component: LandingPage,
        meta: {
            requires_auth: true
        }
    },
    {
        path: "/admin/solutions",
        name: "Solutions",
        component: SolutionsPage,
        meta: {
            requires_auth: true
        }
    },
    {
        path: "/admin/settings",
        name: "Settings",
        component: SettingsView,
        children: [
            {
                path: "/admin/settings",
                component: SettingsView,
                children: [
                    {
                        path: "",
                        name: "settings-view",
                        component: SettingsView,
                        meta: {
                            title: "Settings",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("setRequestSuccess", false);
                            Store.commit("setRequestError", false);
                            next();
                        }
                    },
                    {
                        path: "user-and-company/edit",
                        name: "user-and-company-edit",
                        component: SettingsView,
                        meta: {
                            title: "Edit user and company",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            next();
                        }
                    },
                    {
                        path: "integration/edit",
                        name: "integration-edit",
                        component: SettingsView,
                        meta: {
                            title: "Edit integration",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            next();
                        }
                    },
                    {
                        path: "ui-configuration/edit",
                        name: "ui-configuration-edit",
                        component: SettingsView,
                        meta: {
                            title: "Edit UI Configurations",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            next();
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "/admin/companies",
        name: "companies",
        component: CompaniesList,
        children: [
            {
                path: "/admin/companies",
                component: CompaniesList,
                children: [
                    {
                        path: "",
                        name: "companies-list",
                        component: CompaniesList,
                        meta: {
                            title: "Companies",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", false);
                            Store.commit("setActiveCompany", {});
                            Store.commit("setApiKey", null);
                            Store.commit("setRequestSuccess", false);
                            Store.commit("setRequestError", false);
                            next();
                        }
                    },
                    {
                        path: ":companyId",
                        name: "company-view",
                        component: CompaniesList,
                        meta: {
                            title: "Company",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", true);
                            next();
                        }
                    },
                    {
                        path: ":companyId/edit",
                        name: "company-edit",
                        component: CompaniesList,
                        meta: {
                            title: "Company",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", true);
                            next();
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "/admin/payments-history",
        name: "payment-history",
        component: PaymentHistoryList,
        children: [
            {
                path: "/admin/payments-history",
                component: PaymentHistoryList,
                children: [
                    {
                        path: "",
                        name: "payments-history-list",
                        component: PaymentHistoryList,
                        meta: {
                            title: "Payments",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", false);
                            Store.commit("paymentHistory/setActivePayment", {});
                            Store.commit("setRequestSuccess", false);
                            Store.commit("setRequestError", false);
                            next();
                        }
                    },
                    {
                        path: ":paymentId",
                        name: "payment-history-view",
                        component: PaymentHistoryList,
                        meta: {
                            title: "Payment",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", true);
                            next();
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "/admin/bulk-payments-history",
        name: "bulk-payment-history",
        component: BulkPaymentHistoryList,
        children: [
            {
                path: "/admin/bulk-payments-history",
                component: BulkPaymentHistoryList,
                children: [
                    {
                        path: "",
                        name: "bulk-payments-history-list",
                        component: BulkPaymentHistoryList,
                        meta: {
                            title: "Bulk payments",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", false);
                            Store.commit("bulkPaymentHistory/setActiveBulkPayment", {});
                            Store.commit("setRequestSuccess", false);
                            Store.commit("setRequestError", false);
                            next();
                        }
                    },
                    {
                        path: ":paymentId",
                        name: "bulk-payment-history-view",
                        component: PaymentHistoryList,
                        meta: {
                            title: "Bulk payment",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", true);
                            next();
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "/admin/users",
        name: "users",
        component: UsersList,
        children: [
            {
                path: "/admin/users",
                component: UsersList,
                children: [
                    {
                        path: "",
                        name: "users-list",
                        component: UsersList,
                        meta: {
                            title: "Users",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", false);
                            Store.commit("setActiveUser", {
                                first_name: null,
                                last_name: null,
                                email: null,
                                phone_number: null,
                                role: null,
                                user_status: null,
                                locale: "",
                                capabilities: null
                            });
                            Store.commit("setRequestSuccess", false);
                            Store.commit("setRequestError", false);
                            next();
                        }
                    },
                    {
                        path: ":userId",
                        name: "user-view",
                        component: UsersList,
                        meta: {
                            title: "User",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", true);
                            next();
                        }
                    },
                    {
                        path: ":userId/edit",
                        name: "user-edit",
                        component: UsersList,
                        meta: {
                            title: "Users",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", true);
                            next();
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "/admin/consent",
        name: "Consent",
        component: ConsentView,
        children: [
            {
                path: "/admin/consent",
                component: ConsentView,
                children: [
                    {
                        path: "",
                        name: "consent-list",
                        component: ConsentView,
                        meta: {
                            title: "Consents",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", false);
                            Store.commit("ais/resetActiveAccount", {});
                            Store.commit("ais/resetActiveLogSwift");
                            Store.commit("setRequestSuccess", false);
                            Store.commit("setRequestError", false);
                            next();
                        }
                    },
                    {
                        path: ":accountId/:tabId",
                        name: "consent-account-view",
                        component: ConsentView,
                        meta: {
                            title: "Consents",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", true);
                            next();
                        },
                    },
                ]
            }
        ]
    },
    {
        path: "/admin/general-settings",
        name: "General settings",
        component: GeneralSettingsView,
        children: [
            {
                path: "/admin/general-settings",
                component: GeneralSettingsView,
                children: [
                    {
                        path: "",
                        name: "general-settings-view",
                        component: GeneralSettingsView,
                        meta: {
                            title: "General settings",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("setRequestSuccess", false);
                            Store.commit("setRequestError", false);
                            next();
                        }
                    },
                    {
                        path: "redirect-banks/edit",
                        name: "redirect-banks-edit",
                        component: GeneralSettingsView,
                        meta: {
                            title: "Edit redirect banks",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            next();
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "/app/login",
        name: "Login",
        component: Login,
        beforeEnter: function (to, from, next) {
            Store.commit("toggleDrawer", false);
            Store.commit("setRequestSuccess", false);
            Store.commit("setRequestError", false);
            next();
        }
    },
    {
        path: "/app/logout",
        name: "Logout",
        component: Logout,
        beforeEnter: function (to, from, next) {
            Store.commit("toggleDrawer", false);
            Store.commit("setRequestSuccess", false);
            Store.commit("setRequestError", false);
            next();
        }
    },
    {
        path: "/admin/onboarding",
        name: "adminOnboarding",
        component: OnboardingList,
        children: [
            {
                path: "/admin/onboarding",
                component: OnboardingList,
                children: [
                    {
                        path: "",
                        name: "onboarding-admin-list",
                        component: OnboardingList,
                        meta: {
                            title: "Onboardings",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("onboarding/setActiveOnboarding", {});
                            Store.commit("toggleDrawer", false);
                            Store.commit("setRequestSuccess", false);
                            Store.commit("setRequestError", false);
                            next();
                        }
                    },
                    {
                        path: ":onboardingId",
                        name: "onboarding-admin-view",
                        component: OnboardingList,
                        meta: {
                            title: "Onboardings",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", true);
                            next();
                        }
                    },
                    {
                        path: ":onboardingId/edit",
                        name: "onboarding-admin-edit",
                        component: OnboardingList,
                        meta: {
                            title: "Onboardings",
                            requires_auth: true
                        },
                        beforeEnter: function (to, from, next) {
                            Store.commit("toggleDrawer", true);
                            next();
                        }
                    }
                ]
            }
        ]
    },
    {
        path: "/app/payment/done",
        name: "payment-done",
        component: PaymentDoneView
    },
    {
        path: "/app/payment/info",
        name: "payment-info-view",
        component: PaymentInfoView
    },
    {
        path: "/app/account/select",
        name: "account-select-view",
        component: AccountSelectView
    },
    {
        path: "/app/payment/:paymentId",
        name: "payment-view",
        component: PaymentView
    },
    {
        path: "/app/bulk-payment/:paymentId",
        name: "bulk-payment-view",
        component: BulkPaymentView
    },

    {
        path: "/app/activate",
        name: "activate",
        component: ActivateView
    },

    {
        path: "/app/registration",
        name: "registration",
        component: RegistrationView,
        meta: {
            title: "Company registration",
            requires_auth: false
        }
    },

    {
        path: "/app/onboarding-landing/:hash",
        name: "onboarding",
        component: OnboardingView,
        meta: {
            title: "Onboarding",
            requires_auth: false
        }
    },

    {
        path: "*",
        redirect: "/app/login"
    }
];

const router = new VueRouter({
    mode: "history",
    base: "/",
    routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requires_auth)) {
        if (!Store.state.is_logged_in) {
            return next({name: "Login"});
        } else {
            next();
        }
    } else {
        next();
    }
});
export default router;
